import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/workshop1.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Workshop2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#workshops-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
           Educator<span className="purple"> Workshops</span> 
            </h1>
            <p className="home-about-body">
           At Choicest Fruit<span className="small-r-symbol">®</span>, we believe educators are at the heart of preparing the next generation to use 
           technology responsibly and creatively. Our Educator Workshops provide teachers, administrators, 
           and education professionals with interactive, hands-on sessions that build both technical expertise
            and ethical awareness.
            <br />
            <br />Choicest Fruit Educator Workshops are immersive professional development experiences that 
            equip educators to integrate cutting-edge tools like coding, AI, and digital platforms into their
             classrooms. Beyond technical skills, the workshops emphasize creativity, critical thinking, digital
              citizenship, and ethical innovation, empowering teachers to nurture students who not only use 
              technology but also think critically about its role in society.
            <br />
            <br />Our workshops are designed to be engaging and practical, featuring project-based learning, collaborative
             activities, and real-world applications. Educators leave with actionable strategies, lesson plans,   
             and resources to inspire their students and foster a love of learning in the digital age.            
          </p>
          <p>
            <h1>Learn & Explore</h1>
            Participants gain:
            <ul>
              <li><span className="purple">EdTech Tools </span> – Hands-on experience with coding platforms, AI basics, and classroom tech integration.</li>
              <li><span className="purple">Continued Learning & Certification </span> – Access insights aligned with PD standards, with opportunities for continuing education credits.</li>             
              <li><span className="purple">Ethical Technology </span> – Explore the societal and moral impact of technology, and learn strategies to guide students responsibly.</li>
              <li><span className="purple">Practical Classroom Applications </span> – Design engaging lessons, projects, and activities that spark curiosity and innovation.</li>  
              <li><span className="purple">Networking & Collaboration </span> – Connect with fellow educators to share ideas, challenges, and best practices.</li>
              <li><span className="purple">Ongoing Support </span> – Access to resources, mentorship, and a community of practice to continue learning and growing.</li> 
            </ul>
          </p>
          <p>
            <h1>Collaborative Partnerships</h1>
           These workshops are designed for teachers, administrators, and education professionals who are eager
            to grow their EdTech confidence, enhance their professional toolkit, and bring responsible
             technology practices into their learning environments.
             <br/>
             <br/>
             We also partner with tech companies and industry leaders to co-host workshops on ethical tech and 
             responsible technology development. These collaborations give educators direct access to real-world
              perspectives, tools, and case studies, helping them bring current, value-driven insights into their
               classrooms and preparing students for meaningful engagement in the tech landscape.
          </p>
          <Button onClick={handleClick}>Register Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Workshop2;
